module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Content_Photosets Widget

(function (fox) {
	'use strict';
	fox.registerWidget('Content_Photosets', {

		configure: function (options) {
			this.registerOptions('', {
				container: '#mixed_content',
				template: 'sitepage_photoSets_photoSet_container',
				autoRender: true,
				'widgets.dl': {
					widget: 'Datalayer',
					'filter.contentType': {
						fields: ['contentType'],
						values: [[11]]
					}
				},
				list: {
					container: '#last_added',
					'tpl.row': 'sitepage_photoSets_photoSet'
				}
			});
			
			fox.registerTemplateModifier('isWide', function (obj) {
				if (fox.isEmpty(obj)) return;
				var w = parseInt(obj.width);
				var h = parseInt(obj.height);

				return (w / h > .84);
			});
			this.callParent('configure', arguments);
		},

	}, 'Content_Browser');

})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/widget/content/photosets.js
// module id = 443
// module chunks = 4